import { GoodtrustApiMock } from 'utils/mocks/api.mock'
import { rest } from 'msw'
import { ApiType } from 'utils/types'

export class GoodtrustApiMockPromocodeSlice {
  // eslint-disable-next-line no-useless-constructor
  constructor(private api: GoodtrustApiMock) {}
  handlers() {
    const partner = this.api.mockCobrandedPartner('AOL')

    return [
      rest.post(this.api.prefixed('/api/v1/promocode/validate'), (req, res, ctx) => {
        return res(
          ctx.status(200),
          ctx.json<ApiType['PublicPromoCodeValidationResponse']>({
            offers: [
              {
                amount: 0.5,
                discount_types: ['ESTATE_PLAN'],
                option: 'PERCENTAGE',
                status: 'VALID',
                type: 'DISCOUNT',
                user_usage_limit: 1,
                uuid: 'uuid-offer',
              },
            ],
            promo_code_info: {
              active: true,
              co_branded_partner: true,
              uuid: 'uuid-promo-code',
              code: 'aol5',
              partner: {
                cobranded_partner: 'AOL',
                email: 'mock@example.com',
                partner_photo: partner.partner_photo,
                phone: '+12025550123',
                title: 'Mock Partner AOL',
                url: 'https://example.com',
                uuid: 'mock-uuid-AOL',
              },
              user_count_limit: 1,
            },
          })
        )
      }),
    ]
  }
}
